export class Province {
  id: string;
  name: string;
}
